import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import {sendRequest} from "../../helpers/ajax";
import IChangePasswordRequest from "../../types/IChangePasswordRequest";
import IChangePasswordResponse from "../../types/IChangePasswordResponse";
import IPasswordIsValidRequest from "../../types/IPasswordIsValidRequest";
import IPasswordIsValidResponse from "../../types/IPasswordIsValidResponse";
import IResponse from "../../types/IResponse";
import IUserSession from "../../types/IUserSession";
import ChangePassword from "./ChangePassword";

interface IChangePasswordContainerProps extends RouteComponentProps<any> {
    onLogin: (userSession: IUserSession) => void;
}

class ChangePasswordContainer extends React.Component<IChangePasswordContainerProps>{

    constructor(props: IChangePasswordContainerProps) {
        super(props);

        this.changePassword = this.changePassword.bind(this);
        this.validatePasswordRequirements = this.validatePasswordRequirements.bind(this);
    }

    public render() {
        return (
            <ChangePassword 
                changePassword={this.changePassword} 
                validatePasswordRequirements={this.validatePasswordRequirements}
            />
        );
    }

    private async changePassword(oldPassword: string, password: string): Promise<IResponse<IChangePasswordResponse> | null> {
        const request: IChangePasswordRequest = { oldPassword, password };
        const response = await sendRequest<IResponse<IChangePasswordResponse>>("/api/User/ChangePassword", "POST", request);

        return response;
    }

    private  validatePasswordRequirements(password: string): Promise<IResponse<IPasswordIsValidResponse> | null>  {
        const request: IPasswordIsValidRequest = { password };
        return sendRequest<IResponse<IPasswordIsValidResponse>>("/api/PasswordRequirements/IsValid", "POST", request);
    }

}

export default withRouter(ChangePasswordContainer);




// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePasswordContainer.tsx